import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_djuc44eyt2: FaireBrandEntity = {
  token: "b_djuc44eyt2",
  type: "brand",
  name: "Ora Cacao",
  avatarUrl:
    "https://cdn.faire.com/fastly/f3ddf97e5c363683104f4a2275c3ff38117677ef0a4f12902b4ceed75d0d6f42.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4218218267005fae920e46a3f98a3fecce358a89105b8a3e87d0da4c31ed86cc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f3ddf97e5c363683104f4a2275c3ff38117677ef0a4f12902b4ceed75d0d6f42.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4218218267005fae920e46a3f98a3fecce358a89105b8a3e87d0da4c31ed86cc.jpeg",
  description:
    "The #1 ceremonial cacao brand in the USA and Canada — sourced directly from 1,000+ family farms across five countries. Stanford engineering graduate Jonas Ketterle first encountered sipping chocolate in Oaxaca, Mexico in 2012. Ora Cacao sources directly from over 1,000 family farms in Belize, Colombia, Guatemala, Tanzania, and Uganda — paying 100% above commodity prices.",
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:35.192Z",
    importedBy: "entity-db-cli",
  },
};
